import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .create-payment {
    cursor: pointer;
    text-align: center;
    margin: 16px 0px 0px 8px;
  }

  .delete-payment {
    padding-top: 33px;
  }

  .tooltip-icon {
    color: ${colors.primary.dark};
  }

  .title-tooltip {
    font-size: 1.5em;
  }
  @media (max-width: 600px) {
    .title-tooltip {
      font-size: 1em;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/payment/style.js